import { Box, Icon, Tooltip } from '@nimbus-ds/components';
import { ThumbsUpIcon, ThumbsDownIcon } from '@nimbus-ds/icons';

export type FeedbackType = 'positive' | 'negative' | null;

interface FeedbackButtonsProps {
  feedbackGiven: FeedbackType;
  onPositiveFeedback: () => void;
  onNegativeFeedback: () => void;
  thumbsUpAriaLabel: string;
  thumbsDownAriaLabel: string;
  disabled?: boolean;
  tooltipPosition?: 'top' | 'bottom';
}

function FeedbackButtons({
  feedbackGiven,
  onPositiveFeedback,
  onNegativeFeedback,
  thumbsUpAriaLabel,
  thumbsDownAriaLabel,
  disabled = false,
  tooltipPosition = 'top',
}: Readonly<FeedbackButtonsProps>): JSX.Element {
  return (
    <>
      <Tooltip
        content={thumbsUpAriaLabel}
        position={tooltipPosition}
        arrow
        hidden={feedbackGiven !== null}
      >
        <Box
          as="button"
          display={feedbackGiven === 'negative' ? 'none' : 'flex'}
          justifyContent="center"
          alignItems="center"
          onClick={onPositiveFeedback}
          aria-label={thumbsUpAriaLabel}
          disabled={disabled || feedbackGiven !== null}
          cursor="pointer"
          backgroundColor="transparent"
          borderRadius="2"
          padding="0-5"
          borderWidth="1"
          borderStyle="solid"
          borderColor={{
            xs: 'transparent',
            hover: 'neutral-interactive',
          }}
        >
          <Icon
            source={<ThumbsUpIcon size="small" />}
            color="neutral-textLow"
          />
        </Box>
      </Tooltip>
      <Tooltip
        content={thumbsDownAriaLabel}
        position={tooltipPosition}
        arrow
        hidden={feedbackGiven !== null}
      >
        <Box
          as="button"
          display={feedbackGiven === 'positive' ? 'none' : 'flex'}
          justifyContent="center"
          alignItems="center"
          onClick={onNegativeFeedback}
          aria-label={thumbsDownAriaLabel}
          disabled={disabled || feedbackGiven !== null}
          cursor="pointer"
          backgroundColor="transparent"
          borderRadius="2"
          padding="0-5"
          borderColor={{
            xs: 'transparent',
            hover: 'neutral-interactive',
          }}
          borderWidth="1"
          borderStyle="solid"
        >
          <Icon
            source={<ThumbsDownIcon size="small" />}
            color="neutral-textLow"
          />
        </Box>
      </Tooltip>
    </>
  );
}

export default FeedbackButtons;
